// TODO: simplify when module namespaced
export const PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_STATE = "clearProductChangeOfAddressProcessState";

// TODO: simplify when module namespaced
export const PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_ACTION = "clearProductChangeOfAddressProcessAction";

export const ProductChangeOfAddressProcessStoreActions = {
	CLEAR: `${PRODUCT_CHANGE_OF_ADDRESS_PROCESS_CLEAR_ACTION}`
} as const;
